import React, { useEffect, useRef, useState } from "react";
import { Button, Popover, Space, Row, Table, Popconfirm } from "antd";
import ColumnPopoverDisplay from "components/common/PopoverTable/PopoverTable";
import {
  CalendarSVG,
  CalendarSelectedSVG,
  ExcelSVG,
  ListIconSVG,
  RecycleSVG,
} from "assets";
import ExpandSearch from "components/common/ExpandSearch/ExpandSearch";
import Notification from "components/common/notification/notification";
import { ListActionButton } from "components/common";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";
import { FORMAT_TIME } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import dayjs from "dayjs";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import { ColumnsEdit } from "types/models/column-table-edit";
import {
  allColumnsResidential,
  dataListPatientResidentialFields,
} from "./config";
import { residentialNurse } from "types/enums/residential-nurse";
import residentialNurseService from "api/residentialNurse";
import { setIdDetailSurgery } from "redux/reducer/residentialNurse";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";

const CustomerList: React.FC = () => {
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 50,
    ngayTaoTu: dayjs(),
    ngayTaoDen: dayjs(),
  });

  let savedTableOption = getTableOptions(
    "SURGERY_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumnsResidential.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumnsResidential;

  const [columns, setColumns] = useState<ColumnsEdit>(
    defaultColumns.filter((e) => e.show == true)
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);

  const activeTab = useAppSelector((e) => e.common.activeTab);
  useEffect(() => {
    getList();
  }, [params, activeTab]);

  const handleEdit = (record) => {
    dispatch(setActiveKey(residentialNurse.SURGERY.INFO_DETAIL));
    dispatch(setIdDetailSurgery(record.id));
    dispatch(setIdPhieuKham(record.idPhieuKham));
  };

  const handlePrint = (id) => {};
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      await residentialNurseService.deleteSurgeryById(id);
      getList();
      setLoading(false);
      Notification("success", "Xóa bênh nhân thành công");
    } catch (err) {
      setLoading(false);

      Notification("error", "Xóa bênh nhân không thành công");
    }
  };

  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);

  columns.find((e) => {
    if (e.dataIndex == "action") {
      e.render = (
        value,
        _record: { id: number | string; trangThai: number },
        index
      ) => {
        return (
          <ListActionButton
            editFunction={() => handleEdit(_record)}
            // printFunction={() => handlePrint(_record.id)}
          >
            <Popconfirm
              className="danger-confirm"
              title={`Đồng ý xóa thông tin`}
              onConfirm={() => {
                handleDelete(_record.id);
              }}
            >
              <Button type="ghost" icon={<RecycleSVG />} />
            </Popconfirm>
          </ListActionButton>
        );
      };
    }
    if (e.dataIndex === "stt") {
      e.render = (t, r, i) => {
        const number = (params.page - 1) * params.limit + i + 1;

        return number;
      };
    }
  });

  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "SURGERY_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();

    setParams({
      ...params,
      ...searchFields,
      limit: 10,
      page: 1,
    });
  };

  const getList = async () => {
    setLoading(true);
    const paramsPage = {
      page: params.page,
      limit: params.limit,
    };
    try {
      const res = await residentialNurseService.getLitSurgery(
        formatParams(),
        paramsPage
      );
      const newData = res.data.map((item) => {
        return { ...item, key: item.id };
      });
      setData(newData);

      setTotal(res.total);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };

  const formatParams = () => {
    return {
      ...params,
      ngaySinh:
        formatDateToString(params?.ngaySinh, FORMAT_TIME.invertDayFull) || null,
      ngayTaoDen:
        formatDateToString(params?.ngayTaoDen, FORMAT_TIME.invertDayFull) ||
        null,
      ngayTaoTu:
        formatDateToString(params?.ngayTaoTu, FORMAT_TIME.invertDayFull) ||
        null,
      listIdTrangThaiPhauThuat: params?.listIdTrangThaiPhauThuat
        ? [params.listIdTrangThaiPhauThuat]
        : null,
    };
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selections) => {
      dispatch(setIdPhieuKham(selections[selections.length - 1].idPhieuKham));
      dispatch(setIdDetailSurgery(selections[0].id));
    },
  };

  const onToday = (key: number) => {
    setParams({
      ...params,
      ngayTaoDen: dayjs(),
      ngayTaoTu: dayjs(),
    });

    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setParams({
      ...params,
      ngayTaoDen: dayjs().subtract(1, "day"),
      ngayTaoTu: dayjs().subtract(1, "day"),
      page: 1,
    });

    setSelectedBtn(key);
  };
  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];
  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };

  useEffect(() => {
    if (
      activeTab !== residentialNurse.SURGERY.LIST_PATIENT ||
      activeTab !== residentialNurse.SURGERY.INFO_DETAIL
    ) {
      setIdDetailSurgery(null);
    }
  }, [activeTab]);
  return (
    <div className="list-residential-nurse" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={dataListPatientResidentialFields()}
            onReset={onClickSearchButton}
            initialValues={params}
          />
        </Space>
      </div>

      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
              {/* <Button icon={<ExcelSVG />} className="btn-svg">
                Xuất báo cáo
              </Button> */}
            </Space>
          </Row>

          <CustomResizableTable
            setShowColumns={setShowColumns}
            // scroll={{ x: "100%" }}
            // className="custom-resize-table-scroll"
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              current: params.page,
              onChange: onChangePagination,
            }}
            onRow={(record) => ({
              onDoubleClick: () => handleEdit(record),
            })}
            bordered
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
          />
        </Space>
      </div>
    </div>
  );
};

export default CustomerList;
